export const useNodeEnv = () => {
  const env = window.env.NODE_ENV || 'development';
  const isProd = env === 'production';
  
  return { env, isProd }
}